// Polyfill for Node.js global variable (required by simple-peer)
if (typeof (globalThis as any).global === 'undefined') {
  (globalThis as any).global = globalThis;
}

// Set default theme class on mount to prevent flash
const getInitialTheme = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark') return 'dark';
    if (saved === 'light') return 'light';
    if (saved === 'system') {
      return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    }
  }
  return 'light';
};

// Apply initial theme class immediately to prevent flash
if (typeof document !== 'undefined') {
  const initialTheme = getInitialTheme();
  document.documentElement.classList.add(`theme-${initialTheme}`);
  document.documentElement.setAttribute('data-theme', initialTheme);
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
